// AI Generated Pipe
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fullUrl',
    standalone: false,
})
export class FullUrlPipe implements PipeTransform {
    transform (url: string, domainUrl?: string, pageUrl?: string): string {
        url = url || '';
        url = url.trim();

        if (domainUrl === null || domainUrl === undefined || url[0] !== '/') {
            if (url.match(/:\/\//)) {
                return url;
            } else if (pageUrl === null || pageUrl === undefined) {
                return url;
            } else {
                const urlBase = pageUrl.substring(0, pageUrl.lastIndexOf('/'));
                return urlBase + '/' + url;
            }
        }

        const hostRegex = new RegExp('^(https?://)([^/?#?]+)(?:[/?#]|$)', 'i');
        const matches = domainUrl.match(hostRegex);
        if (matches && matches.length >= 3) {
            url = matches[1] + matches[2] + url;
        }

        return url;
    }
}
